import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2, Timer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QuizConfig } from "@/components/learning/QuizConfig";
import { QuizRunner } from "@/components/learning/QuizRunner";
import { docsApi } from "@/lib/apiClient";
import { useTranslation } from "@/context/LanguageContext";
import { toast } from "sonner";

export default function Exam() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [doc, setDoc] = useState(null);
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try { setDoc(await docsApi.get(id)); }
            catch (e) { toast.error(t("examPage.loadFailed")); navigate("/library"); }
            finally { setLoading(false); }
        })();
    }, [id, navigate, t]);

    if (loading) return <div className="flex min-h-screen items-center justify-center bg-surface-0"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--primary))]" /></div>;
    if (!doc) return null;

    return (
        <div className="min-h-screen bg-surface-0">
            <header className="sticky top-0 z-20 border-b border-border bg-surface-0/85 backdrop-blur-md">
                <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-3 sm:px-6">
                    <Button data-testid="exam-back-button" variant="ghost" size="icon" className="text-t2" onClick={() => navigate(`/study/${id}`)}><ArrowLeft className="h-5 w-5" /></Button>
                    <div className="min-w-0">
                        <div className="flex items-center gap-1.5 text-[hsl(var(--warning))]"><Timer className="h-3.5 w-3.5" /><span className="mono-label">{t("examPage.mode")}</span></div>
                        <h1 className="truncate font-sans-display text-sm font-semibold text-t1 sm:text-base">{doc.title}</h1>
                    </div>
                </div>
            </header>

            <div className="mx-auto max-w-3xl px-4 py-6 sm:px-6">
                {config ? (
                    <QuizRunner docId={id} config={config} onExit={() => setConfig(null)} />
                ) : (
                    <div>
                        <div className="mb-4 rounded-2xl border border-border bg-surface-1 p-5">
                            <h2 className="font-sans-display text-base font-semibold text-t1">{t("examPage.mockTitle")}</h2>
                            <p className="mt-1 text-sm text-t3">{t("examPage.mockDesc")}</p>
                        </div>
                        <QuizConfig mode="exam" onStart={(opts) => setConfig(opts)} />
                    </div>
                )}
            </div>
        </div>
    );
}
